<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="所属养殖户">
              <!--              <j-dict-select-tag placeholder="请选择所属养殖户" v-model="queryParam.userId" dictCode="sys_user,realname,id,user_types=4"/>-->
              <a-input v-model="queryParam.realname" placeholder="请输入所属养殖户名称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="耳标号">
              <a-input v-model="queryParam.tagsNumber" placeholder="请输入耳标号"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="所属乡镇">
              <j-dict-select-tag
                dict-code="town_beef"
                v-model="queryParam.townshipId"
                placeholder="请选择负责乡镇"
                type="select"
              ></j-dict-select-tag>
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="品种">
                <j-dict-select-tag
                  placeholder="请选择品种"
                  v-model="queryParam.varietyName"
                  dictCode="varieties_types"
                />
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="当前状态">
                <j-dict-select-tag placeholder="请选择当前状态" v-model="queryParam.statusing" dictCode="beef_status" />
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('基础母牛表')">导出</a-button>

      <!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl"-->
      <!--                @change="handleImportExcel">-->
      <!--        <a-button type="primary" icon="import">导入</a-button>-->
      <!--      </a-upload>-->
      <!-- 高级查询区域 -->
      <!--      <j-super-query :fieldList="superFieldList" ref="superQueryModal"  @handleSuperQuery="handleSuperQuery"></j-super-query>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="0" @click="checkBatch">
            <a-icon type="check-circle" />
            审核
          </a-menu-item>
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{ x: true }"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width:80px;font-size: 12px;font-style: italic;"
          />
        </template>
        <template slot="towSignSrc" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width:80px;font-size: 12px;font-style: italic;"
          />
        </template>
        <template slot="couSignSrc" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width:80px;font-size: 12px;font-style: italic;"
          />
        </template>
        <template slot="calvingNumber" slot-scope="text, record">
          <a-tooltip>
            {{ text }}
            <a-button icon="search" type="primary" size="small" @click="showBeefCalf(record)"></a-button>
            <template slot="title">
              只统计终审通过的牛犊数
            </template>
          </a-tooltip>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button v-else :ghost="true" type="primary" icon="download" size="small" @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <!--<a @click="handleDetail(record)">详情</a>-->
          <a-button size="small" type="primary" @click="clickDetail(record)">详情</a-button>
          <!-- <a-button size="small" style="background:green;color:#fff" @click="selecttime('cs', record)"
            >审核通过</a-button
          >
          <a-button size="small" type="danger" @click="selecttime('jz', record)">审核拒绝</a-button> -->
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleEdit(record)">编辑</a>
              </a-menu-item>
              <!--              <a-menu-item>-->
              <!--                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">-->
              <!--                  <a>删除</a>-->
              <!--                </a-popconfirm>-->
              <!--              </a-menu-item>-->
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <beef-cattle-modal ref="modalForm" @ok="modalFormOk"></beef-cattle-modal>
    <beef-cattle-detail-modal time="2023" ref="detailModal" @ok="modalFormOk"></beef-cattle-detail-modal>
    <a-modal
      v-model="visibleCheck"
      :title="'共 ' + checkUserRows.length + ' ，是否通过审核'"
      @ok="handleCheckBatchOk"
      width="80%"
      :confirm-loading="loadingTag"
    >
      <a-table
        :columns="columnsCattle"
        :scroll="{ x: true }"
        :data-source="checkUserRows"
        bordered
        rowKey="id"
        style="margin-top: 10px"
        :loading="loadingTag"
      >
        <template slot="imgSlot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-avatar shape="square" :src="getAvatarView(record.photos)" icon="user" />
          </div>
        </template>
        <template slot="towSignSrc" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width:80px;font-size: 12px;font-style: italic;"
          />
        </template>
        <template slot="couSignSrc" slot-scope="text, record">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            :preview="record.id"
            height="25px"
            alt=""
            style="max-width:80px;font-size: 12px;font-style: italic;"
          />
        </template>
        <span slot="action" slot-scope="text, record">
          <!--<a @click="handleDetail(record)">详情</a>-->
          <a-button size="small" type="primary" @click="clickDetail(record)">详情</a-button>
        </span>
      </a-table>
      <template slot="footer">
        <a-button @click="visibleCheck = false">取消</a-button>
        <a-button @click="handleCheckBatchNo" type="danger">驳回</a-button>
        <a-button @click="handleCheckBatchOk" type="primary">通过</a-button>
      </template>
    </a-modal>
    <a-modal v-model="visibleBeefCalfList" title="犊牛列表" @ok="visibleBeefCalfList = false" width="80%">
      <beef-cattle-small-list2 ref="beefCattleCalf"></beef-cattle-small-list2>
    </a-modal>
    <a-modal v-model="visibleCheckNo" title="输入年份" @ok="jsorcs">
      <a-input v-model="time" />
    </a-modal>
    <a-modal v-model="visibleCheckFail" title="驳回原因" @ok="handleCheckBatchNoSub">
      <a-input v-model="checkRemark" />
    </a-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import BeefCattleModal from './modules/BeefCattleModal'
import BeefCattleDetailModal from './modules/BeefCattleDetailModal1'
import { postAction, getAction } from '../../api/manage'
import Vue from 'vue'
import { USER_INFO, ENHANCE_PRE } from '@/store/mutation-types'
import BeefCattleSmallList2 from '../beef/BeefCattleSmallList32023'

export default {
  name: 'BeefCattleList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    BeefCattleDetailModal,
    BeefCattleSmallList2,
    BeefCattleModal
  },
  data() {
    return {
      description: '牛犊表管理页面',
      selectjzOrcs: '',
      time: '2023',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '耳标号',
          align: 'center',
          dataIndex: 'tagsNumber'
        },
        {
          title: '毛色',
          align: 'center',
          dataIndex: 'coatColor'
        },
        {
          title: '生日',
          align: 'center',
          sorter: true,
          dataIndex: 'birthday',
          customRender: function(text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text
          }
        },
        {
          title: '月龄',
          align: 'center',
          dataIndex: 'monthOld'
        },
        {
          title: '品种',
          align: 'center',
          dataIndex: 'varietyName_dictText'
        },
        {
          title: '当前状态',
          align: 'center',
          dataIndex: 'statusing_dictText'
        },
        {
          title: '产犊数',
          align: 'center',
          dataIndex: 'calvingNumber',
          scopedSlots: { customRender: 'calvingNumber' }
        },
        {
          title: '牛照片',
          align: 'center',
          dataIndex: 'photos',
          scopedSlots: { customRender: 'imgSlot' }
        },
        {
          title: '所属乡镇',
          align: 'center',
          dataIndex: 'townshipId_dictText'
        },
        {
          title: '所属养殖户',
          align: 'center',
          dataIndex: 'userId_dictText'
        },
        // {
        //   title: '牛类型',
        //   align: 'center',
        //   dataIndex: 'types_dictText'
        // },
        // {
        //   title: '镇审核签字',
        //   align: 'center',
        //   dataIndex: 'towSignSrc',
        //   scopedSlots: { customRender: 'towSignSrc' }
        // },
        // {
        //   title: '县级管理审核签字',
        //   align: 'center',
        //   dataIndex: 'couSignSrc',
        //   scopedSlots: { customRender: 'couSignSrc' }
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
      ],
      columnsCattle: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '耳标号',
          align: 'center',
          dataIndex: 'tagsNumber'
        },
        {
          title: '毛色',
          align: 'center',
          dataIndex: 'coatColor'
        },
        // {
        //   title: '月龄',
        //   align: 'center',
        //   dataIndex: 'monthOld'
        // },
        {
          title: '出生日期',
          align: 'center',
          dataIndex: 'birthday'
        },
        {
          title: '品种',
          align: 'center',
          dataIndex: 'varietyName_dictText'
        },
        {
          title: '所属乡镇',
          align: 'center',
          dataIndex: 'townshipId_dictText'
        },
        {
          title: '当前状态',
          align: 'center',
          dataIndex: 'statusing_dictText'
        },
        // {
        //   title: '牛照片',
        //   align: 'center',
        //   dataIndex: 'photos',
        //   scopedSlots: { customRender: 'imgSlot' }
        // },
        // {
        //   title: '性别',
        //   align: 'center',
        //   dataIndex: 'gender_dictText'
        // },
        // {
        //   title: '母牛耳标',
        //   align: 'center',
        //   dataIndex: 'beefNumber'
        // },
        {
          title: '所属养殖户',
          align: 'center',
          dataIndex: 'userId_dictText'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 147,
          scopedSlots: { customRender: 'action' }
        }
        // {
        //   title: '镇审核签字',
        //   align: 'center',
        //   dataIndex: 'towSignSrc',
        //   scopedSlots: { customRender: 'towSignSrc' }
        // }
      ],
      url: {
        list: '/beef/beefCattle/list',
        batchCheck: '/beef/beefCattle/checkCountyCattle',
        delete: '/beef/beefCattle/delete',
        deleteBatch: '/beef/beefCattle/deleteBatch',
        exportXlsUrl: '/beef/beefCattle/exportXlsBeef',
        importExcelUrl: 'beef/beefCattle/importExcel',
        JZAPI: 'beef/beefCattle/createHis',
        CSAPI: 'beef/beefCattle/transfer'
      },
      dictOptions: {},
      superFieldList: [],
      loadingTag: false,
      checkUserRows: [],
      visibleCheck: false,
      userInfo: '',
      visibleBeefCalfList: false,
      checkRemark: '',
      visibleCheckNo: false,
      visibleCheckFail: false,
      queryParam: {
        belongYear: 2023
      }
    }
  },
  created() {
    this.getSuperFieldList()
  },
  mounted() {
    // console.log('mounted::', this.$route.query)
    this.queryParam.userId = this.$route.query.userId
    this.queryParam.realname = this.$route.query.realname
    if (this.queryParam.userId) {
      this.isLoading()
    }
    this.userInfo = Vue.ls.get('Login_Userinfo')
  },
  computed: {
    importExcelUrl: function() {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    searchReset() {
      this.queryParam = {
        belongYear: 2023
      }
      this.loadData()
    },
    isYearValid(year) {
      const yearPattern = /^[1-9]\d{3}$/
      return yearPattern.test(year)
    },
    selecttime(type, row) {
      this.selectjzOrcs = type
      // this.visibleCheckNo = true
      this.jsorcs(row)
    },
    jsorcs(row) {
      this.$confirm({
        title: '审核',
        content: `您确定要审核${this.selectjzOrcs == 'jz' ? '拒绝' : '通过'}吗?`,
        onOk: () => {
          const flag = this.isYearValid(this.time)
          if (!flag && this.time) {
            this.$message.info('请输入正确的年份')
            return
          }
          getAction(this.selectjzOrcs == 'jz' ? this.url.JZAPI : this.url.CSAPI, { belongYear: this.time, id: row.id })
            .then(res => {
              if (res.success) {
                this.$message.success(res.message)
              } else {
                this.$message.warning(res.message)
              }
            })
            .finally(final => {
              this.visibleCheck = false
              this.loadingTag = false
              this.visibleCheckNo = false
              this.checkUserRows = []
              this.checkRemark = ''
              this.loadData()
            })
        },
        onCancel: () => {}
      })
    },
    showBeefCalf(record) {
      this.visibleBeefCalfList = true
      this.$nextTick(() => {
        this.$refs.beefCattleCalf.querySetBeef(record)
      })
    },
    querySet(record) {
      this.queryParam.userId = record.id
      this.queryParam.realname = record.realname
      if (this.queryParam.userId) {
        this.isLoading()
      }
    },
    handleCheckBatchNo() {
      // this.checkPost('6')
      this.visibleCheckFail = true
    },
    handleCheckBatchOk() {
      this.checkPost('3')
    },
    handleCheckBatchNoSub() {
      if (!this.checkRemark) {
        this.$message.warning('请输入驳回原因')
        return
      }
      this.checkPost('6')
    },
    checkPost(statusing) {
      let data = []
      this.checkUserRows.forEach(item => {
        data.push({
          tagsNumber: item.tagsNumber,
          userId: item.userId,
          statusing,
          remark: statusing == 6 ? this.checkRemark : ''
        })
      })
      if (data.length == 0) {
        this.$message.warning('暂无待审核')
        return
      }
      this.loadingTag = true

      postAction(this.url.batchCheck, data)
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
          } else {
            this.$message.warning(res.message)
          }
        })
        .finally(final => {
          this.visibleCheck = false
          this.loadingTag = false
          this.visibleCheckNo = false
          this.visibleCheckFail = false
          this.checkUserRows = []
          this.checkRemark = ''
          this.loadData()
        })
    },
    checkBatch() {
      console.log('checkBatch', this.selectedRowKeys, this.selectionRows)
      this.visibleCheck = true
      this.checkUserRows = []
      let checkStatus = this.userInfo && this.userInfo.userTypes == '3' ? '1' : '2'
      this.selectionRows.forEach(item => {
        if (checkStatus === item.statusing) {
          this.checkUserRows.push(item)
        }
      })
    },
    isLoading() {
      if (!this.loading) {
        this.searchQuery()
      } else {
        setTimeout(() => {
          this.isLoading()
        }, 500)
      }
    },
    toPages(record) {
      let pageUrl = '/beef/smallCattle2'
      this.$router.push(pageUrl + '?beefNumber=' + record.tagsNumber)
    },
    clickDetail(record) {
      this.$refs.detailModal.show(record)
    },
    initDictConfig() {},
    getSuperFieldList() {
      let fieldList = []
      fieldList.push({ type: 'int', value: 'tagsNumber', text: '耳标号（1和2有耳标）', dictCode: '' })
      fieldList.push({ type: 'string', value: 'coatColor', text: '毛色', dictCode: '' })
      fieldList.push({ type: 'date', value: 'birthday', text: '生日' })
      fieldList.push({ type: 'string', value: 'monthOld', text: '根据生日计算', dictCode: '' })
      fieldList.push({ type: 'string', value: 'userId', text: '所属用户', dictCode: '' })
      fieldList.push({ type: 'string', value: 'varietyName', text: '品种', dictCode: 'varieties_types,,' })
      fieldList.push({ type: 'string', value: 'statusing', text: '当前状态', dictCode: 'beef_status,,' })
      fieldList.push({ type: 'int', value: 'calvingNumber', text: '产犊数', dictCode: '' })
      fieldList.push({ type: 'Text', value: 'photos', text: '牛照片', dictCode: '' })
      fieldList.push({
        type: 'string',
        value: 'types',
        text: '牛类型（1.基础母牛，2.犊牛，3.备用母牛，4.肉牛，5.公牛）',
        dictCode: 'beef_types,,'
      })
      fieldList.push({ type: 'string', value: 'delFlag', text: '删除标签（1.已删除）', dictCode: '' })
      fieldList.push({ type: 'Text', value: 'towSignSrc', text: '镇审核签字', dictCode: '' })
      fieldList.push({ type: 'Text', value: 'couSignSrc', text: '县级管理审核签字', dictCode: '' })
      fieldList.push({ type: 'string', value: 'gender', text: '性别', dictCode: 'beef_gender,,' })
      this.superFieldList = fieldList
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
